// extracted by mini-css-extract-plugin
module.exports = {"mobile":"style_mobile__2XQx7","tablet":"style_tablet__oodNq","desktop":"style_desktop__1HGlz","router":"style_router__1xxEF"};